import { defineComponent as _defineComponent } from 'vue'
import '@patsnap-ui/icon/assets/solid/MapPinOn.svg';
import '@patsnap-ui/icon/assets/solid/NoDataTip.svg';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';
import { ref, computed, watch } from 'vue';
import { Icon as PtIcon } from 'patsnap-biz';
import { useI18n } from '@/composables/use-i18n';
import { useDomNodesTip } from '@/components/dom-nodes-tip/use-dom-nodes-tip';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { GetPatentPum } from '@/infrastructure/api-functions/core-search-api/get-patent-pum-api';
import { useTranslationStates } from '@/composables/use-translation-states';

interface PropertyItem {
    index: number;
    raw_unit: string;
    display_name: string;
    raw_measurement: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PumProperties',
  props: {
    patentId: null
  },
  setup(__props: any) {

const props = __props as {
    patentId: string;
}



const { t } = useI18n();
const { initNodesTip } = useDomNodesTip();
const { currentTranslateLanguages } = useTranslationStates();

const getPatentPumApi = injectService<GetPatentPum>(GetPatentPum);

const activeIndex = ref<number | null>(null);

const pumData = ref<PropertyItem[]>([]);

const isLoading = ref(true);

const isNodata = computed(() => !pumData.value.length);

const handleItemClick = (index: number) => {
    activeIndex.value = index;
    const selector = `${props.patentId}-pum-${index}`;
    initNodesTip({
        selector,
        notFoundMessage: t('pumParaNotFound'),
    });
};

const getPumData = async () => {
    isLoading.value = true;
    const lang = currentTranslateLanguages.value.left;
    const res = await getPatentPumApi.getPatentPum({
        lang,
        patentId: props.patentId,
    });
    pumData.value = (res.MATERIAL_PUM_TRAN?.length > 0 ? res.MATERIAL_PUM_TRAN : res.MATERIAL_PUM) || [];
    isLoading.value = false;
};

watch(currentTranslateLanguages, () => {
    getPumData();
}, { immediate: true });


return { __sfc: true,props, t, initNodesTip, currentTranslateLanguages, getPatentPumApi, activeIndex, pumData, isLoading, isNodata, handleItemClick, getPumData, PtIcon }
}

})